<!-- Dialog: Change Password from User Settings  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-normal change-password-container"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title_text }} </p-header>
  <div class="change-password-entry">
    <span>
      <bfx-text-input
        inputLabelText="{{data.dialogData.field.old}}"
        password="true"
        autocomplete="off"
        [(ngModel)]="oldPassword"
        (ngModelChange)="validatePasswordField(0)"
        [disabled]="changePasswordSubmitted"
        size="sm"
        [maxLength]="maxPasswordLength"
        [ngClass]="{'valid': validPasswordField[0]===true, 'invalid': validPasswordField[0]===false}"
      ></bfx-text-input>
    </span>
  </div>
  <div class="change-password-entry">
    <span>
      <bfx-text-input
        inputLabelText="{{data.dialogData.field.new}}"
        password="true"
        autocomplete="off"
        [(ngModel)]="newPassword"
        (ngModelChange)="validatePasswordField(1)"
        [disabled]="changePasswordSubmitted"
        size="sm"
        [maxLength]="maxPasswordLength"
        [ngClass]="{'valid': validPasswordField[1]===true, 'invalid': validPasswordField[1]===false}"
      ></bfx-text-input>
    </span>
  </div>
  <div class="change-password-entry">
    <div class="progress-bar-container">
      <div
        [style.width.%]="(newPasswordStrength / 4) * 100"
        [class]="'progress-bar-value ' + newPasswordStrengthColor"
      ></div>
    </div>
    <div>{{ newPasswordStrengthMessage }} Strength</div>
  </div>
  <div class="change-password-entry">
    <span>
      <bfx-text-input
        inputLabelText="{{data.dialogData.field.confirm}}"
        password="true"
        autocomplete="off"
        [(ngModel)]="newPasswordConfirmation"
        (ngModelChange)="validatePasswordField(2)"
        [disabled]="changePasswordSubmitted"
        size="sm"
        [maxLength]="maxPasswordLength"
        [ngClass]="{'valid': validPasswordField[1]===true, 'invalid': validPasswordField[1]===false}"
      ></bfx-text-input>
    </span>
  </div>
  <div class="bfx-callout-warning-md" *ngIf="passwordWarningMessage">
    <i class="icon-warning"></i>
    <span>{{passwordWarningMessage}}</span>
  </div>
  <div class="bfx-callout-negative-md" *ngIf="generalPasswordError">
    <i class="icon-error"></i>
    <span>{{generalPasswordError}}</span>
  </div>
  <div class="change-password-info">{{data.dialogData.general.warning}}</div>

  <p-footer fxLayout="row">
    <div class="action-row">
      <button
        class="bfx-button-secondary-subtle"
        [disabled]="changePasswordSubmitted"
        (click)="cancelChangePassword()"
      >
        {{data.dialogData.action.cancel}}
      </button>
      <button
        class="bfx-button-primary"
        [disabled]="savePasswordDisabled || changePasswordSubmitted"
        (click)="changePassword()"
      >
        {{data.dialogData.action.change}}
      </button>
    </div>
  </p-footer>
</p-dialog>
